module.exports = __webpack_public_path__ + "static/sam-adams-043aa26d65c54ae9558b98a0468a83d2.svg";